import React from 'react'
import { Box, Typography } from 'components'
import { Chip } from '@material-ui/core'
import { useContent } from 'utils'

export function UnionFilter({ filterState: state, setFilterState: setState }) {
  const { selectedUnions = [] } = state
  const { unions } = useContent()
  
  const unionTags = unions || []

  const onUnionTagChange = (tag) => {
    // Convert tag to proper format - this matches the data structure in user profiles
    const unionObject = { name: tag, memberType: 'Member' }
    
    // Check if this union already exists in the selected unions
    const exists = selectedUnions.some(union => {
      // Handle both string values and object values in the current state
      if (typeof union === 'string') {
        return union === tag
      } else {
        return union.name === tag
      }
    })
    
    if (exists) {
      // Remove the union by filtering out all matches
      setState({ 
        ...state, 
        selectedUnions: selectedUnions.filter(union => {
          // Handle both string and object formats
          const unionName = typeof union === 'string' ? union : union.name
          return unionName !== tag
        }) 
      })
    } else {
      // Add the union as an object with the correct format
      setState({ ...state, selectedUnions: [...selectedUnions, unionObject] })
    }
  }
  
  return (
    <Box py={1.5} flex={1} flexVariant="space-between align-center" minHeight="fit-content">
      <Box display="flex" alignItems="center" flex={1} flexDirection="column">
        <Typography variant="subtitle1" style={{ marginBottom: '10px' }}>Unions</Typography>
        <Box
          display="flex"
          alignItems="center"
          flex={1}
          flexDirection="row"
          flexWrap="wrap"
          width="30dvw">
          {unionTags.map((tag) => {
            // Check if this union is selected, handling both string and object formats
            const isSelected = selectedUnions.some(union => {
              if (typeof union === 'string') {
                return union === tag
              } else {
                return union.name === tag
              }
            })
            return (
              <Chip 
                label={tag} 
                key={tag} 
                style={{ margin: 2 }} 
                variant={isSelected ? 'default' : 'outlined'} 
                color='primary'
                onClick={() => onUnionTagChange(tag)} 
              />
            )
          })}
        </Box>
      </Box>
    </Box>
  )
}
